var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"map-legend"},[_c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"dot urgent"}),_vm._v(" 有定金")]),_c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"dot main"}),_vm._v(" 主推酒店")]),_c('div',{staticClass:"legend-item"},[_c('span',{staticClass:"dot normal"}),_vm._v(" 普通酒店")])])
}]

export { render, staticRenderFns }